document.addEventListener("login", (e) => {
  if (e.detail.err) { 

    console.log(e.detail.data.code)

    var error = $('.login-error')
 
    switch(e.detail.data.code) {
      case 'auth/invalid-email':
        error.text('Please enter a valid email address')
        break;
      case 'auth/user-not-found':
        error.text('User not found.')
        break;
      default: 
        error.text('Incorrect email or password.')
        break;
    }

    error.show(); 
    document.getElementById("loginFirebase").removeAttribute("aria-busy")
  }
});

document.addEventListener("passReset", (e) => {

  var error = $('.reset-error');

  if (e.detail.err) { 
    error.text('Please enter a valid email address')
    error.show().delay(5000).fadeOut('fast'); 
    document.getElementById("FirebaseResetSubmit").removeAttribute("aria-busy")
  }
  
})